import { render, staticRenderFns } from "./ShowLabelPriceBlock.vue?vue&type=template&id=7ae99880&scoped=true"
import script from "./ShowLabelPriceBlock.vue?vue&type=script&lang=js"
export * from "./ShowLabelPriceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae99880",
  null
  
)

export default component.exports